export default __webpack_public_path__ + "static/media/background.d7506014.png";